(function() {
	angular.module('app.supplyChain')
		.directive('leanSpark', leanSpark);

	function leanSpark() {
		// holding onto a cache of chart elements to reuse on redraws
		var charts = {};

		return {
			template: '<div class="chart"></div>',
			scope: {
				values: '=',
				suppliers: '=',
				key: '='
			},
			link: link
		};

		function link(scope, element, attrs, controller, transcludeFn) {
			// cache key on supplier ids and values
			var id = scope.values.join(':') + '|' + scope.suppliers.join(':') + '|' + scope.key;
			var container = angular.element(element.find('.chart'))[0];
			if (!charts[id]) {
				// chart has never been rendered so create element and store in cache
				charts[id] = document.createElement('div');
				// delay chart generation since it does not work properly before element
				// is added to dom
				window.setTimeout(generate, 0);
			}
			/* insert element to the current cell */
			container.appendChild(charts[id]);

			function generate() {
				c3.generate({
					bindto: charts[id],
					transition: {
						duration: null
					},
					data: {
						columns: [
							['delPerf'].concat(scope.values)
						],
						type: 'area'
					},
					legend: {
						show: false
					},
					tooltip: { show: false },
					axis: {
						x: {
							show:false
						},
						y: {
							show:false,
							min: 0,
							max: 100
						}
					},
					size: {
						height:33,
						width:80
					},
					point: {
						show: true,
						r: 0
					},
					line: {
						connectNull: true
					}
				});
			}
		}
	}
})();